import React from 'react';
const painPoints = ['Sin saber qué constituye un delito digital cuando el agresor tiene 10 años', 'Sin un protocolo claro para las primeras horas después de un incidente', 'Sin actividades listas para trabajar bullying con chicos de 6 a 12 años', 'Sin saber cómo hablarle a las familias sin generar pánico ni conflicto', 'Con miedo a decir algo incorrecto frente a los padres o al supervisor', 'Sin recursos visuales para que los alumnos reflexionen y se comprometan', 'Sabiendo que algo puede pasar y sin estar preparado/a para actuar'];
export function ProblemSection() {
  return <section className="bg-[#F5F5F5] py-6 md:py-12 lg:py-[60px]" data-id="element-170">
      <div className="container mx-auto px-4" data-id="element-171">
        <div className="max-w-4xl mx-auto text-center mb-6 md:mb-8" data-id="element-172">
          <h2 className="text-[#1B3A6B] font-poppins font-black text-3xl md:text-5xl mb-4 md:mb-5" data-id="element-173">
            ¿Cuántas situaciones más vas a enfrentar sin saber exactamente qué
            hacer?
          </h2>

          <div className="text-[#2C2C2C] text-lg md:text-xl space-y-3 md:space-y-4 mb-5 md:mb-6" data-id="element-174">
            <p data-id="element-175">
              Un alumno llega llorando porque lo excluyen todos los días en el
              recreo. O encontrás un grupo de WhatsApp donde se burlan de una
              nena de tu grado. O un padre llega furioso a la dirección porque
              su hijo fue amenazado por otro chico en Instagram.
            </p>
            <p className="font-bold" data-id="element-176">
              En ese momento no hay tiempo para buscar en Google. No hay tiempo
              para improvisar. No hay tiempo para equivocarse.
            </p>
          </div>

          <h3 className="text-[#1B3A6B] font-poppins font-bold text-2xl mb-3" data-id="element-177">
            Nadie te preparó para ese silencio en la sala de docentes cuando
            algo grave pasa y todos te miran esperando que sepas exactamente qué
            hacer.
          </h3>
          <p className="text-[#555555] italic" data-id="element-178">
            No es falta de vocación. Es falta de herramientas concretas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-3 md:gap-4 max-w-5xl mx-auto mb-6 md:mb-8" data-id="element-179">
          {painPoints.map((point, i) => <div key={i} className="bg-white p-4 md:p-5 rounded-xl flex items-start gap-3 shadow-sm" data-id="element-180">
              <span className="text-[#E63946] text-xl font-bold" data-id="element-181">✗</span>
              <p className="text-[#2C2C2C] font-medium" data-id="element-182">{point}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-183">
          <h4 className="text-[#1B3A6B] font-poppins font-bold text-2xl md:text-4xl inline-block relative" data-id="element-184">
            <span className="relative z-10" data-id="element-185">
              ¿Y si esta fuera la última vez que enfrentás una situación así
              completamente sin herramientas?
            </span>
            <div className="absolute bottom-0 left-0 w-full h-4 bg-[#FFD700] opacity-30 -rotate-1" data-id="element-186"></div>
          </h4>
        </div>
      </div>
    </section>;
}